<template>
  <div class="complete-step">
    <div class="containe">
      <SvgIcon href="/galka" name="galka" width="50px" height="40px" class="galka"></SvgIcon>
      <h2>{{complete.h2}}</h2>
      <span>{{complete.span}}</span>
      <Buttons class="btn-primary" @click="$parent.complete">{{complete.button}}</Buttons>
    </div>
  </div>
</template>

<script>

export default {
  name: "Complete",
  props:['complete']
};
</script>

<style lang="scss" scoped>
.complete-step {
  padding-top: 80px;
  text-align: center;
  .galka {
    margin-bottom: 48px;
  }
  h2 {
    font-weight: bold;
    font-size: 32px;
    line-height: 40px;
    color: #333;
    margin-bottom: 24px;
  }
  span {
    display: block;
    margin: 0 auto;
    max-width: 624px;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    margin-bottom: 40px;
  }
  .btn-primary{
      width: 224px;
      padding: 16px 0;
  }
}
</style>